import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import BreadcrumbsContext from './BreadcrumbsContext';
const AutoDocumentTitle = ({ rootTitle, separator = ' :: ', }) => {
    const { breadcrumbs } = useContext(BreadcrumbsContext);
    const titleItems = [
        rootTitle,
        ...breadcrumbs.slice(1).map(crumb => crumb.title),
    ];
    titleItems.reverse();
    return (<Helmet>
      <title>{titleItems.join(separator)}</title>
    </Helmet>);
};
export default AutoDocumentTitle;
